import { onClickUrl, onShortUrl } from '../../core/events.js';

let rendered = false;
let currentUrl = null;

function isAndroid() {
  return /Android/i.test(navigator.userAgent || '');
}

function styleButtonLikePill(node) {
  node.style.padding = '0.6rem 1rem';
  node.style.borderRadius = '999px';
  node.style.border = '1px solid #000';
  node.style.background = '#000';
  node.style.color = '#fff';
}

function buildContainer() {
  const wrap = document.createElement('div');
  wrap.style.display = 'flex';
  wrap.style.flexWrap = 'wrap';
  wrap.style.justifyContent = 'center';
  wrap.style.gap = '12px';
  wrap.style.margin = '0.75rem 0 1rem';
  return wrap;
}

function createCopyButton(urlRef) {
  const copyButton = document.createElement('button');
  copyButton.type = 'button';
  copyButton.textContent = 'Copy link';
  styleButtonLikePill(copyButton);

  copyButton.addEventListener('click', () => {
    if (!urlRef.current) return;
    navigator.clipboard.writeText(urlRef.current).then(() => {
      copyButton.textContent = 'Copied!';
      setTimeout(() => {
        copyButton.textContent = 'Copy link';
      }, 1500);
    });
  });

  return copyButton;
}

function createEmailLink(urlRef) {
  const emailLink = document.createElement('a');
  emailLink.textContent = 'Email me this link';
  emailLink.style.textDecoration = 'none';
  styleButtonLikePill(emailLink);

  const setMailto = () => {
    emailLink.href =
      `mailto:?subject=${encodeURIComponent('Oblik Design – iOS app link')}` +
      `&body=${encodeURIComponent(`Open this on your iPhone to install:\n${urlRef.current || ''}`)}`;
  };

  setMailto();
  return { emailLink, setMailto };
}

function createSmsLink(urlRef) {
  const smsLink = document.createElement('a');
  smsLink.textContent = 'Text link';
  smsLink.style.textDecoration = 'none';
  styleButtonLikePill(smsLink);

  const setSms = () => {
    smsLink.href = `sms:?body=${encodeURIComponent(`Get the Oblik app on your iPhone: ${urlRef.current || ''}`)}`;
  };

  setSms();
  return { smsLink, setSms };
}

function createShareButton(urlRef) {
  if (!navigator.share) return null;

  const shareButton = document.createElement('button');
  shareButton.type = 'button';
  shareButton.textContent = 'Share';
  styleButtonLikePill(shareButton);

  shareButton.addEventListener('click', () => {
    if (!urlRef.current) return;
    navigator.share({ text: `Get the Oblik app on your iPhone: ${urlRef.current}` }).catch(() => {});
  });

  return shareButton;
}

function render(initialUrl) {
  if (rendered) return;
  rendered = true;
  currentUrl = initialUrl;

  const container = document.getElementById('link-actions');
  if (!container) {
    console.warn('Link actions: #link-actions not found; buttons will not be rendered.');
    return;
  }

  const wrap = buildContainer();
  const urlRef = { current: initialUrl };

  wrap.appendChild(createCopyButton(urlRef));

  const { emailLink, setMailto } = createEmailLink(urlRef);
  wrap.appendChild(emailLink);

  let setSms = null;

  if (isAndroid()) {
    const sms = createSmsLink(urlRef);
    setSms = sms.setSms;
    wrap.appendChild(sms.smsLink);

    const shareButton = createShareButton(urlRef);
    if (shareButton) wrap.appendChild(shareButton);
  }

  const updateUrl = (url) => {
    if (!url) return;
    urlRef.current = url;
    currentUrl = url;
    setMailto();
    if (setSms) setSms();
  };

  onShortUrl((event) => updateUrl(event.detail?.url));
  onClickUrl((event) => {
    if (window._oblikShortURL) return;
    updateUrl(event.detail?.url);
  });

  container.appendChild(wrap);
}

export function initLinkActions() {
  const initialUrl = window._oblikShortURL || window._oblikClickURL;
  if (initialUrl) render(initialUrl);

  onShortUrl((event) => {
    if (rendered) return;
    render(event.detail?.url);
  });

  onClickUrl((event) => {
    if (rendered) return;
    render(event.detail?.url);
  });
}
